import { Box } from '@frontend/components';

import { BILLING_INFO_TYPES } from '../constants';
import OneTimeAddressDisplay from './OneTimeAddressDisplay';

type BillingInformationDisplayProps = {
  billingAddress: any;
  billingInformation: any;
  type: string;
};

const BillingInformationDisplay = ({
  billingAddress,
  billingInformation,
  type,
}: BillingInformationDisplayProps) => {
  switch (type) {
    case BILLING_INFO_TYPES.NONE:
      return 'None';
    case BILLING_INFO_TYPES.ONE_TIME_ADDRESS:
      return <OneTimeAddressDisplay address={billingInformation} />;
    case BILLING_INFO_TYPES.BILLING_ADDRESS:
      return (
        <Box fontSize="sm">
          {billingAddress.address.address1}
          <br />
          {billingAddress.address.address2 && (
            <>
              {billingAddress.address.address2}
              <br />
            </>
          )}
          <p>
            {billingAddress.address.city}
            {billingAddress.address.state && (
              <>
                ,&nbsp;
                {billingAddress.address.state.abbr}
              </>
            )}
            {billingAddress.address.postalCode && (
              <>&nbsp;{billingAddress.address.postalCode}</>
            )}
          </p>
        </Box>
      );
    default:
      return 'None';
  }
};

export default BillingInformationDisplay;
